module.exports = __webpack_public_path__ + "static/media/country_ir.2aa6dacf.webp";